export const shippingTags = [
  'shipping_documentAddDelete',
  'shipping_newVoyage',
  'shipping_modifyAdd',
  'invoices_add',
  'master_newVoyage',
  'master_shipping_companies',
  'master_shipping-agents',
  'master_shipping-charges',
] as const;
